export default __webpack_public_path__ + "static/13-skeena-west-label-cd81d5c4a1d5cea128dbc2f1a89d0ceb.svg";